<template>
  <div id="app">
    <router-view></router-view>
    <template v-if="$route.name!='404'">
      <Footer/>
    </template>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  name: "app",
  components: {
    Footer
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  overflow: hidden;
}

body {
  font-weight: 400;
  font-size: 12px;
  color: #333;
}

* {
  margin: 0;
  padding: 0;
}

em, i {
  font-style: normal;
}

li {
  list-style: none;
}

a {
  text-decoration: none ;
  /*outline: none;!important;*/
  cursor: pointer;
  color: #222;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
a:hover{
  text-decoration: none ;
}
img {
  border: none;
}

input, textarea {
  vertical-align: middle;
  outline: none;
  border: none;
  background: none;
  box-sizing: border-box;
}

input[type=number] {
  -moz-appearance:textfield;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

textarea {
  overflow: auto;
}

table {
  border-spacing: 0;
  border: none;
  border-collapse: collapse;
}

button {
  border: none;
  cursor: pointer;
}
button:focus,
button:active{
  outline: none;
  border-color: transparent;
  box-shadow:none;
}
.container{
  width: 1196px;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.flex {
  display: flex;
}
.flex_between {
  -webkit-justify-content: space-between;
  -ms-justify-content: space-between;
  justify-content: space-between;
}
.flex_around {
  -webkit-justify-content: space-around;
  -ms-justify-content: space-around;
  justify-content: space-around;
}
.flex_center {
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.flex_column {
  -webkit-flex-direction: column ;
  -ms-flex-direction: column ;
  flex-direction: column ;
}
.flex_wrap {
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.clearBoth:after{
  display: block;
  content: "";
  height: 0;
  clear: both;
}

@font-face {
  font-family: 'iconfont';  /* project id 2358178 */
  src: url('//at.alicdn.com/t/font_2358178_3gw78dy1jnv.eot');
  src: url('//at.alicdn.com/t/font_2358178_3gw78dy1jnv.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_2358178_3gw78dy1jnv.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_2358178_3gw78dy1jnv.woff') format('woff'),
  url('//at.alicdn.com/t/font_2358178_3gw78dy1jnv.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_2358178_3gw78dy1jnv.svg#iconfont') format('svg');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.modal_bg{
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
}
.modal_body {
  position: fixed;
  z-index: 11;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.modal_body .icon-guanbi {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}

.section_contact{
  width: 100%;
  background: #2678CB;
}
.section_contact.fixed{
  position: fixed;
  left:0;
  right:0;
  bottom:0;
  z-index: 10;
}
</style>
